module.exports = __webpack_public_path__ + "static/bookCoverSample-541a9ad711e22426560a049ccf23960b.jpg";